<template>
  <div class="czzn-fpgl">
    <div class="czsc-con">
      <div class="czsc-nr-tit">【销项发票】</div>
      <p>销项发票是增值税一般纳税人销售货物、提供加工、修理修配劳务以及提供应税服务向客户开具的增值税发票</p>
      <p>1、提取销项发票</p>
      <p>点击左侧菜单中【发票管理】→【销项发票】→【导入】按钮，可以提取销项发票；</p>
      <img src="@/assets/images/czzn_026.png" />
      <div class="czsc-nr-hsbj-box">
        <p>注：</p>
        <p>① 目前只支持Excel数据的导入；</p>
        <p>② Excel数据是从增值税发票综合服务平台下载的Excel，具体下载方式，请参照销项发票导入的温馨提示；</p>
      </div>
      <p>2、导入发票成功后，如图</p>
      <img src="@/assets/images/czzn_027.png" />
      <p>3、选择需要生成凭证的发票数据，在复选框里打√，全选时点击列表中的复选框，点击“生成凭证”，弹出生成凭证界面如下图所示；</p>
      <img src="@/assets/images/czzn_028.png" />
      <p>4、选择凭证日期、摘要、科目，以及生成方式后，即可根据所选的发票生成凭证；</p>
      <p>5、生成凭证后，在列表中即可看到对应的凭证号，点击凭证号进入凭证界面查询凭证；</p>
      <img src="@/assets/images/czzn_029.png" />
      <img src="@/assets/images/czzn_030.png" />
      <p>6、销项发票中的“更多条件”支持按照开票日期、发票号、购方名称、是否生成凭证等信息查询发票；</p>
      <img src="@/assets/images/czzn_031.png" />
      <div class="czsc-nr-tit">【进项发票】</div>
      <p>进项发票支持已抵扣、未抵扣，未抵扣转为已抵扣三种生成凭证的方式</p>
      <p>1、提取进项发票</p>
      <p>点击左侧菜单中【发票管理】→【进项发票】→【导入】按钮，可以提取进项发票；</p>
      <img src="@/assets/images/czzn_032.png" />
      <div class="czsc-nr-hsbj-box">
        <p>注：</p>
        <p>① 支持已抵扣、未抵扣两种Excel数据的导入；</p>
        <p>② Excel数据是从增值税发票综合服务平台下载的Excel，具体下载方式，请参照进项发票导入的温馨提示</p>
      </div>
      <p>2、导入成功后</p>
      <img src="@/assets/images/czzn_033.png" />
      <p>3、选择需要生成凭证的发票数据，在复选框里打√，全选时点击列表中的复选框，点击“生成凭证”，弹出生成凭证界面；</p>
      <img src="@/assets/images/czzn_034.png" />
      <p>4、选择好摘要、科目，生成方式后，即可根据所选的发票生成凭证；</p>
      <p>5、生成凭证后，在列表中即可看到对应的凭证号，点击凭证号进入凭证界面查询凭证；</p>
      <img src="@/assets/images/czzn_035.png" />
      <img src="@/assets/images/czzn_036.png" />
      <P>6、进项发票中的“更多条件”支持按照开票日期、发票号、销方名称、是否生成凭证等信息查询发票</P>
      <img src="@/assets/images/czzn_037.png" />
      <p>7、未抵扣发票、未抵扣转为已抵扣，这两张方式生成凭证的同已抵扣发票生成一致，在此不再赘述；</p>
      <div class="czsc-nr-tit">【查询统计】</div>
      <p>销项发票增加了商品销售明细、发票汇总统计查询，为用户提供了按照商品和购方不同维度的查询统计。</p>
      <p>1、点击左侧菜单中【发票管理】→【销售商品明细】，即可查询；</p>
      <img src="@/assets/images/czzn_038.png" />
      <p>2、点击左侧菜单中【发票管理】→【发票汇总统计】，即可查询；</p>
      <img src="@/assets/images/czzn_039.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'czzn_fpgl',
};
</script>
